export const checkboxItemClasses = [
  'peer',
  'h-sizing-comp-checkbox-check',
  'w-sizing-comp-checkbox-check',
  'p-0.5',
  'shrink-0',
  // because the container is of flex the hidden input was beeing redered before the checkbox
  // instead of in top of the checkbox
  '[&~input]:!translate-x-0',
  // uncheched
  '[&_svg]:text-color-comp-checkbox-unchecked-default',
  '[&:not(:disabled):hover_svg]:text-color-comp-checkbox-unchecked-hover',
  '[&:disabled_svg]:text-color-comp-checkbox-unchecked-disabled',
  '[&:has(~input:invalid)_svg]:text-color-comp-checkbox-unchecked-danger',
  '[&[aria-invalid=true]_svg]:text-color-comp-checkbox-unchecked-danger',
  // checked
  '[&[data-state=checked]_svg]:text-color-comp-checkbox-checked-default',
  '[&:not(:disabled):hover[data-state=checked]_svg]:text-color-comp-checkbox-checked-hover',
  '[&:disabled[data-state=checked]_svg]:text-color-comp-checkbox-checked-disabled',
  '[&:has(~input:invalid)[data-state=checked]_svg]:text-color-comp-checkbox-checked-danger',
  '[&[aria-invalid=true][data-state=checked]_svg]:text-color-comp-checkbox-checked-danger',
  // indeterminate
  '[&[data-state=indeterminate]_svg]:text-color-comp-checkbox-checked-default',
  '[&:not(:disabled):hover[data-state=indeterminate]_svg]:text-color-comp-checkbox-checked-hover',
  '[&:disabled[data-state=indeterminate]_svg]:text-color-comp-checkbox-checked-disabled',
  '[&:has(~input:invalid)[data-state=indeterminate]_svg]:text-color-comp-checkbox-checked-danger',
  '[&[aria-invalid=true][data-state=indeterminate]_svg]:text-color-comp-checkbox-checked-danger',
  // has a label after
  '[&:has(~label)]:mr-spacing-comp-checkbox-gap',
  // common lib overrides are giving the button a default border on focus
  // we need to remove it
  'focus-visible:outline-none',
  'focus:outline-none',
  // add focus styles for keyboard accessibility purposes
  'focus-visible:rounded',
  'focus-visible:outline-offset-0',
  'focus-visible:outline-2',
  'focus-visible:outline-color-ref-ui-focus-default',
];

export const checkboxLabelClasses = [
  'flex',
  'items-center',
  'gap-spacing-comp-checkbox-gap',
  'font-comp-checkbox-label-font-family',
  'font-comp-checkbox-label-font-weight',
  'text-font-comp-checkbox-label-font-size',
  'peer-[:not(:disabled)]:cursor-pointer',
  'text-color-comp-checkbox-label-default',
  'peer-hover:text-color-comp-checkbox-label-hover',
  'peer-invalid:text-color-comp-checkbox-label-error',
  '[&[aria-invalid=true]]:text-color-comp-checkbox-unchecked-danger [&[aria-invalid=true]_svg]:fill-current',
];
